import { CdkMenuItem } from '@angular/cdk/menu';
import { NgIf } from '@angular/common';
import { booleanAttribute, Component, inject, Input } from '@angular/core';
import { BrMenuComponent } from './menu.component';
import { BrIconComponent } from '../icon/icon.component';

@Component({
  selector: 'button[brMenuItem]',
  standalone: true,
  imports: [NgIf, BrIconComponent],
  hostDirectives: [{
    directive: CdkMenuItem,
    inputs: ['cdkMenuItemDisabled: disabled', 'cdkMenuitemTypeaheadLabel: label'],
    outputs: ['cdkMenuItemTriggered: triggered'],
  }],
  host: {
    'type': 'button',
    '(focus)': 'syncFocus()',
    '[disabled]': 'item.disabled',
    '[attr.aria-current]': 'current ? "true" : null',
    '[class.br-menu-item--current]': 'current',
  },
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.css'],
})
export class BrMenuItemComponent {
  readonly item = inject(CdkMenuItem);
  private readonly menu = inject(BrMenuComponent, { optional: true });

  syncFocus(): void { this.menu?.syncFocusedItem(this.item); }

  @Input() icon = '';
  /** The caller owns the current choice; the menu never stores a second copy. */
  @Input({ transform: booleanAttribute }) current = false;
}
